// extracted by mini-css-extract-plugin
export default {"spacing":"LoginSkeleton_spacing__mtks1"};